// Class: motion.easing._Quint.QuintEaseInOut

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var QuintEaseInOut = function() {
}

// Meta

QuintEaseInOut.__name__ = ["motion","easing","_Quint","QuintEaseInOut"];
QuintEaseInOut.__isInterface__ = false;
QuintEaseInOut.__interfaces__ = [(motion_easing_IEasing().default)];
QuintEaseInOut.prototype = {
	calculate: function(k) {
		if((k *= 2) < 1) {
			return 0.5 * k * k * k * k * k;
		}
		return 0.5 * ((k -= 2) * k * k * k * k + 2);
	},
	ease: function(t,b,c,d) {
		if((t /= d / 2) < 1) {
			return c / 2 * t * t * t * t * t + b;
		}
		return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	}
};
QuintEaseInOut.prototype.__class__ = QuintEaseInOut.prototype.constructor = $hxClasses["motion.easing._Quint.QuintEaseInOut"] = QuintEaseInOut;

// Init



// Statics




// Export

exports.default = QuintEaseInOut;